// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: N4buk5LIp3R
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { Reveal } from "@plasmicpkgs/react-awesome-reveal";
import FormEnterButton from "../../FormEnterButton"; // plasmic-import: a-Kq7ZTga5/component
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicForm.module.css"; // plasmic-import: N4buk5LIp3R/css

createPlasmicElementProxy;

export const PlasmicForm__VariantProps = new Array("transparentBackground");

export const PlasmicForm__ArgProps = new Array();

const $$ = {};

function PlasmicForm__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "transparentBackground",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.transparentBackground
      },
      {
        path: "fname.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "First Name"
      },
      {
        path: "lname.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "Last Name"
      },
      {
        path: "wemail.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "Work Email"
      },
      {
        path: "cityresidence.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "City"
      },
      {
        path: "industry.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "Industry"
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        {
          [sty.roottransparentBackground]: hasVariant(
            $state,
            "transparentBackground",
            "transparentBackground"
          )
        }
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__svvk)}>
        <Reveal
          data-plasmic-name={"reveal"}
          data-plasmic-override={overrides.reveal}
          cascade={true}
          className={classNames("__wab_instance", sty.reveal)}
          triggerOnce={true}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__c8A0W, {
              [sty.freeBoxtransparentBackground__c8A0Wa7Rdh]: hasVariant(
                $state,
                "transparentBackground",
                "transparentBackground"
              )
            })}
          >
            <div className={classNames(projectcss.all, sty.freeBox__wxKk5)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__gkmrt,
                  {
                    [sty.texttransparentBackground__gkmrta7Rdh]: hasVariant(
                      $state,
                      "transparentBackground",
                      "transparentBackground"
                    )
                  }
                )}
              >
                {hasVariant(
                  $state,
                  "transparentBackground",
                  "transparentBackground"
                ) ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ fontWeight: 700 }}
                    >
                      {"Small or Medium-Sized Business Looking for Insights? "}
                    </span>
                  </React.Fragment>
                ) : (
                  "Build the perfect experience around every customer"
                )}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__c6Rc2,
                  {
                    [sty.texttransparentBackground__c6Rc2A7Rdh]: hasVariant(
                      $state,
                      "transparentBackground",
                      "transparentBackground"
                    )
                  }
                )}
              >
                {
                  "Millions of community-generated data points to guide every decision you make"
                }
              </div>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__crCjZ)}>
            <div className={classNames(projectcss.all, sty.columns__ggz6)}>
              <div className={classNames(projectcss.all, sty.column__k82SB)}>
                <input
                  data-plasmic-name={"fname"}
                  data-plasmic-override={overrides.fname}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.fname,
                    {
                      [sty.fnametransparentBackground]: hasVariant(
                        $state,
                        "transparentBackground",
                        "transparentBackground"
                      )
                    }
                  )}
                  onChange={e => {
                    generateStateOnChangeProp($state, ["fname", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"First Name"}
                  ref={ref => {
                    $refs["fname"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    generateStateValueProp($state, ["fname", "value"]) ?? ""
                  }
                />
              </div>
              <div className={classNames(projectcss.all, sty.column__cTHi)}>
                <input
                  data-plasmic-name={"lname"}
                  data-plasmic-override={overrides.lname}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.lname,
                    {
                      [sty.lnametransparentBackground]: hasVariant(
                        $state,
                        "transparentBackground",
                        "transparentBackground"
                      )
                    }
                  )}
                  onChange={e => {
                    generateStateOnChangeProp($state, ["lname", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"Last Name"}
                  ref={ref => {
                    $refs["lname"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    generateStateValueProp($state, ["lname", "value"]) ?? ""
                  }
                />
              </div>
            </div>
            <div className={classNames(projectcss.all, sty.columns__wvcVn)}>
              <div className={classNames(projectcss.all, sty.column__ubfkE)}>
                <input
                  data-plasmic-name={"wemail"}
                  data-plasmic-override={overrides.wemail}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.wemail,
                    {
                      [sty.wemailtransparentBackground]: hasVariant(
                        $state,
                        "transparentBackground",
                        "transparentBackground"
                      )
                    }
                  )}
                  onChange={e => {
                    generateStateOnChangeProp($state, ["wemail", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"Work Email"}
                  ref={ref => {
                    $refs["wemail"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    generateStateValueProp($state, ["wemail", "value"]) ?? ""
                  }
                />
              </div>
            </div>
            <div className={classNames(projectcss.all, sty.columns__dqTGd)}>
              <div className={classNames(projectcss.all, sty.column__u7O8)}>
                <input
                  data-plasmic-name={"cityresidence"}
                  data-plasmic-override={overrides.cityresidence}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.cityresidence,
                    {
                      [sty.cityresidencetransparentBackground]: hasVariant(
                        $state,
                        "transparentBackground",
                        "transparentBackground"
                      )
                    }
                  )}
                  onChange={e => {
                    generateStateOnChangeProp($state, [
                      "cityresidence",
                      "value"
                    ])(e.target.value);
                  }}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["cityresidence"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    generateStateValueProp($state, [
                      "cityresidence",
                      "value"
                    ]) ?? ""
                  }
                />
              </div>
            </div>
            <div className={classNames(projectcss.all, sty.columns__e6E6O)}>
              <div className={classNames(projectcss.all, sty.column__gPlWm)}>
                <input
                  data-plasmic-name={"industry"}
                  data-plasmic-override={overrides.industry}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.industry,
                    {
                      [sty.industrytransparentBackground]: hasVariant(
                        $state,
                        "transparentBackground",
                        "transparentBackground"
                      )
                    }
                  )}
                  onChange={e => {
                    generateStateOnChangeProp($state, ["industry", "value"])(
                      e.target.value
                    );
                  }}
                  placeholder={"Industry"}
                  ref={ref => {
                    $refs["industry"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={
                    generateStateValueProp($state, ["industry", "value"]) ?? ""
                  }
                />
              </div>
            </div>
            <div className={classNames(projectcss.all, sty.freeBox__iWywe)}>
              <FormEnterButton
                data-plasmic-name={"formEnterButton"}
                data-plasmic-override={overrides.formEnterButton}
                className={classNames("__wab_instance", sty.formEnterButton)}
              />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "reveal",
    "fname",
    "lname",
    "wemail",
    "cityresidence",
    "industry",
    "formEnterButton"
  ],

  reveal: [
    "reveal",
    "fname",
    "lname",
    "wemail",
    "cityresidence",
    "industry",
    "formEnterButton"
  ],

  fname: ["fname"],
  lname: ["lname"],
  wemail: ["wemail"],
  cityresidence: ["cityresidence"],
  industry: ["industry"],
  formEnterButton: ["formEnterButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicForm__ArgProps,
          internalVariantPropNames: PlasmicForm__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicForm";
  } else {
    func.displayName = `PlasmicForm.${nodeName}`;
  }
  return func;
}

export const PlasmicForm = Object.assign(
  // Top-level PlasmicForm renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    reveal: makeNodeComponent("reveal"),
    fname: makeNodeComponent("fname"),
    lname: makeNodeComponent("lname"),
    wemail: makeNodeComponent("wemail"),
    cityresidence: makeNodeComponent("cityresidence"),
    industry: makeNodeComponent("industry"),
    formEnterButton: makeNodeComponent("formEnterButton"),
    // Metadata about props expected for PlasmicForm
    internalVariantProps: PlasmicForm__VariantProps,
    internalArgProps: PlasmicForm__ArgProps
  }
);

export default PlasmicForm;
/* prettier-ignore-end */
